import React, { useState } from 'react';
import { Col, Label, Row, Input, FormGroup, FormFeedback, FormText, ButtonGroup, Button, InputGroup, InputGroupAddon, InputGroupText, CardBody } from 'reactstrap';
import 'moment/locale/es';
import "react-datetime/css/react-datetime.css";
import './StyleCompany.css'
import { TabMenu } from 'primereact/tabmenu';





export const FormCompany = (props) => {

	const {
		handleInputChange, validaciones,
		states, companyTurn, listTaxRegime, handleChangeState, microsite, password_microsite, category, is_block,
		payment_by_company, payment_by_patient,
		require_invoice, available_invoice_patient, credit_days,
		handleAddCompany, listCompanyBusinessNames, handleDinamicInputRFC,
		id_company_turn, code, name, customer_since,
		username, results_email, button,
		removeAlterCompanies, requirements,
		handleChangePaymentBy, stamp_invoice, handleInputChangeWithPrefix, generateRandomPassword,
		handleNewBussines, handleAddressInput, handleDeleteAddress, listDays
	} = props;

	const [showPassword, setShowPassword] = useState(false);

	const {
		id_company_turn_valid,
		code_valid,
		name_valid,
		customer_since_valid,
	} = validaciones;
	const [activeIndex, setActiveIndex] = useState(0);

	const items = [
		{ label: 'Datos generales', icon: 'pi pi-id-card' },
		{ label: 'Datos fiscales', icon: 'pi pi-file' }
	];


	const toggleShowPassword = () => {
		setShowPassword((prevShowPassword) => !prevShowPassword);
	};

	return (
		<>
			<TabMenu
				model={items}
				activeIndex={activeIndex}
				onTabChange={(e) => setActiveIndex(e.index)}
				className="custom-tabmenu full-width custom-tabmenu-orange"
				style={{ marginBottom: "10px" }}
			/>

			{activeIndex === 0 && (
				<div>
					<CardBody className='pt-0' >
						<Row>
							<Col sm="12" md="12" lg="12" className='pt-2 p-l-1 p-r-1' >

								<Row className='pt-0 form-section'>
									<Col md="12" className="d-flex justify-content-between align-items-center mb-3">
										<h6 className="section-title">
											<i className="pi pi-folder-open"></i>
											Información General
										</h6>

										<small className="section-warning-absolute">
											<i className="fa fa-exclamation-circle me-1"></i>&nbsp;
											Complete los campos requeridos
										</small>
									</Col>

									<Col sm="3">
										<FormGroup>
											<Label className="label-admision">Nombre <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
											<Input
												type="text"
												className="input-admision"
												name="name"
												value={name}
												autoComplete="nope"
												onChange={handleInputChange}
												invalid={name_valid} />
											<FormFeedback>Ingresa un nombre valido</FormFeedback>
										</FormGroup>
									</Col>
									<Col sm="3">
										<FormGroup>
											<Label className="label-admision">Código <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
											<Input
												className="input-admision"
												type="text"
												name="code"
												value={code}
												autoComplete="off"
												onChange={handleInputChangeWithPrefix}
												invalid={code_valid}
											/>
											<FormFeedback>Ingresa un nombre valido</FormFeedback>
										</FormGroup>
									</Col>
									<Col sm="3">
										<FormGroup>
											<Label className="label-admision" >Cliente desde <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
											<Input type='date' placeholder='YYYY-MM-DD' name='customer_since' value={customer_since} className="input-admision"
												onChange={handleInputChange} />

											<FormText color="danger" hidden={!customer_since_valid}>Selecciona una fecha</FormText>
										</FormGroup>
									</Col>
									<Col sm="3">
										<FormGroup>
											<Label className="label-admision">Requerimientos especiales </Label>
											<FormGroup>
												<Input
													type='text'
													name="requirements"
													className="input-admision"
													onChange={handleInputChange}
													value={requirements}
												/>
											</FormGroup>
										</FormGroup>
									</Col>
									<Col md="12">
										<FormGroup>
											<Label className="label-admision">Correo electrónico para envío de resultados &nbsp; <label style={{ color: "#1d5b83" }} > (En caso de requerir más de un correo separar con el símbolo&nbsp;"," ) </label></Label>
											<Input
												className="input-admision"
												type="text"
												name="results_email"
												autoComplete="nope"
												onChange={handleInputChangeWithPrefix}
												value={results_email}
											/>
										</FormGroup>

									</Col>
								</Row>

								<Row className='pt-0 form-section' >
									<Col md="12" className="d-flex justify-content-between align-items-center mb-3">
										<h6 className="section-title">
											<i className="pi pi-wallet"></i>
											Configuración de cobranza
										</h6>


									</Col>
									<Col sm="3">
										<FormGroup>
											<Label className="label-admision">Giro comercial <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
											<Input
												className="input-admision"
												type="select"
												name="id_company_turn"
												onChange={handleInputChange}
												defaultValue={id_company_turn}>
												<option value={0}>Selecciona una opción</option>
												{
													companyTurn.length > 0 && companyTurn.map((c, key) => {
														return <option key={key} value={c.id_company_turn} selected={(id_company_turn === c.id_company_turn) ? 'selected' : ''}>{c.name}</option>
													})
												}
											</Input>
											<FormText color="danger" hidden={!id_company_turn_valid}>Selecciona una opción</FormText>
										</FormGroup>
									</Col>
									<Col sm="3">
										<Label className="label-admision">Categorías<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
										<FormGroup className="m-0">
											<Input
												type='select'
												className="input-admision"
												name="category"
												value={category}
												onChange={handleInputChange}
											>
												<option value={1}>{"A - Sin limite "}</option>
												<option value={2}>{"B - Limite fijo con tolerancia"}</option>
												<option value={3}>{"C - Monto fijo"}</option>
											</Input>
										</FormGroup>
									</Col>
									<Col sm="3">
										<Label className="label-admision">Generar cobro a <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
										<FormGroup className="m-0">
											<Input type='select' value={payment_by_company && payment_by_patient ? "0" : (payment_by_company ? "2" : "1")} autoComplete='off'
												className="input-admision"
												onChange={(e) => handleChangePaymentBy(e)}
											>
												<option value="2">A la empresa</option>
												<option value="1">A el paciente</option>
												<option value="0">Ambas partes</option>
											</Input>
										</FormGroup>
									</Col>
									<Col sm="3">
										<Label className="label-admision">Credito<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
										<FormGroup className="m-0">
											<Input
												type='select'
												className="input-admision"
												name="credit_days"
												value={credit_days}
												onChange={handleInputChange}
												defaultValue={credit_days}

											>
												<option value={0}>Selecciona una opción</option>
												{
													listDays.length > 0 && listDays.map((c, key) => {
														return <option key={key} value={c.id_payment_configuration} selected={(credit_days === c.id_payment_configuration) ? 'selected' : ''}>{c.method}</option>
													})
												}

											</Input>
										</FormGroup>
									</Col>

								</Row>

								<Row className='pt-0 form-section'>
									<Col md="12" className="d-flex justify-content-between align-items-center mb-3">
										<h6 className="section-title">
											<i className="pi pi-file-pdf"></i>
											Configuración de facturación
										</h6>

									</Col>
									<Col sm="3">
										<FormGroup >
											<Label className="label-admision">Requiere factura la empresa <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
											<Label className="switch" style={{ display: 'flex', alignItems: 'center' }}>
												<Input type="checkbox" name="require_invoice" onChange={handleInputChange} checked={require_invoice} />
												<span className="slider round"></span>
											</Label>
										</FormGroup>
									</Col>

									<Col sm="3">
										<FormGroup>
											<Label className="label-admision">Requiere factura el paciente <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
											<Label className="switch" style={{ display: 'flex', alignItems: 'center' }}>
												<Input type="checkbox" name="available_invoice_patient" onChange={handleInputChange} checked={available_invoice_patient} disabled={require_invoice} />
												<span className="slider round"></span>
											</Label>
										</FormGroup>
									</Col>
									<Col sm="3">
										<FormGroup>
											<Label className="label-admision">Visualizar Factura <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
											<Label className="switch" style={{ display: 'flex', alignItems: 'center' }}>
												<Input type="checkbox" name="stamp_invoice" onChange={handleInputChange} checked={stamp_invoice} />
												<span className="slider round"></span>
											</Label>
										</FormGroup>
									</Col>
								</Row>

								<Row className='pt-0 form-section' >
									<Col md="12" className="d-flex justify-content-between align-items-center mb-3">
										<h6 className="section-title">
											<i className="pi pi-wrench"></i>
											Configuración de acciones
										</h6>

									</Col>
									<Col sm="3">
										<FormGroup >
											<Label className="label-admision">Microsito del cliente <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
											<Label className="switch" style={{ display: 'flex', alignItems: 'center' }}>
												<Input type="checkbox" name="microsite" onChange={handleInputChange} checked={microsite} />
												<span className="slider round"></span>
											</Label>
										</FormGroup>
									</Col>

									{microsite && (
										<Col sm="3">
											<FormGroup>
												<Label className="label-admision">
													Código Micrositio
													<span className='f-16' style={{ color: "#0079C7" }}>*</span>
												</Label>

												<Input
													type="text"
													className="input-admision"
													name="username"
													value={username}
													onChange={handleInputChangeWithPrefix}
													disabled={!microsite}
												/>
											</FormGroup>
										</Col>
									)}

									<Col sm="3" className={microsite ? '' : 'd-none'} >
										<FormGroup>
											<Label className="label-admision">Ingresa tu contraseña <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
											<InputGroup>
												<Input
													type={showPassword ? 'text' : 'password'}
													className="input-admision"
													name="password_microsite"
													value={password_microsite}
													onChange={handleInputChange}
													placeholder="Contraseña"
												/>
												<InputGroupAddon addonType="append">
													<InputGroupText>
														<span
															className={`fa fa-eye${showPassword ? '-slash' : ''}`}
															onClick={toggleShowPassword}
															style={{ cursor: 'pointer' }}
														/>
													</InputGroupText>
												</InputGroupAddon>
												<InputGroupAddon addonType="append">
													<InputGroupText onClick={generateRandomPassword} style={{ cursor: "pointer" }}>
														<span className="fa fa-lock" />
													</InputGroupText>
												</InputGroupAddon>
											</InputGroup>
										</FormGroup>
									</Col>
									<Col sm="3">
										<FormGroup>
											<Label className="label-admision">
												{
													(is_block === 0 || is_block === "0")
														? <i className="icofont icofont-lock text-danger f-20"></i>
														: <i className="fa fa-unlock-alt text-success f-20"></i>
												}
												&nbsp; Bloquear cliente
												<span className='f-16' style={{ color: "#0079C7" }}>*</span>
											</Label>

											<FormGroup>
												<Input
													type='select'
													className="input-admision"
													name="is_block"
													value={is_block}
													onChange={handleInputChange}
												>
													<option value={0}>{"Si"}</option>
													<option value={1}>{"No"}</option>
												</Input>
											</FormGroup>
										</FormGroup>
									</Col>
								</Row>
							</Col>
						</Row>
					</CardBody>
				</div>
			)}

			{activeIndex === 1 && (
				<div>

					<Col sm="12" className='pt-2'  >
						{
							listCompanyBusinessNames.length >= 1 && listCompanyBusinessNames.map((obj, index) => {
								return (
									<Row className='pt-0 form-section' style={{ placeContent: "center" }} key={index + 1}>
										<Col md="12" className="d-flex justify-content-between align-items-center mb-3">
											<h6 className="section-title">
												<i className="pi pi-building"></i>
												Datos fiscales
											</h6>

											<small className="section-warning-absolute">
												<i className="fa fa-exclamation-circle me-1"></i>&nbsp;
												Complete los campos requeridos
											</small>
										</Col>

										<Col sm="12" >
											<Row>
												<Col md="5" >
													<FormGroup>
														<Label className="label-admision">Nombre / Razón social <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
														<Input
															className="input-admision"
															type="text"
															name="business_name"
															autoComplete="nope"
															onChange={(e) => handleDinamicInputRFC(e, "business_name", "listCompanyBusinessNames")}
															value={obj.business_name}
															data-id={index}
														/>
														<FormFeedback>Ingresa una direccion valida</FormFeedback>
													</FormGroup>
												</Col>
												<Col md="3">
													<FormGroup>
														<Label className="label-admision">RFC <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
														<Input
															type="text"
															className="input-admision"
															name="rfc"
															value={obj.rfc}
															autoComplete="off"
															onChange={(e) => handleDinamicInputRFC(e, "rfc", "listCompanyBusinessNames")}
															data-id={index}
														/>
														<FormFeedback>RFC invalido</FormFeedback>
													</FormGroup>
												</Col>
												<Col sm="1" className='pt-2' style={{ textAlign: "-webkit-center" }}>
													<FormGroup>


														<Label>Default</Label> <br />
														<Input
															type='radio'
															name="is_default"
															checked={obj.is_default}
															onChange={(e) => handleDinamicInputRFC(e, "is_default", "listCompanyBusinessNames")}
															data-id={index}
														/>
													</FormGroup>
												</Col>
												<Col sm="3" className='pt-3' >
													<button
														onClick={() => handleAddCompany()}
														style={{
															background: "linear-gradient(135deg, #f59e0b, #f97316)",
															color: "#fff",
															border: "none",
															borderRadius: "8px",
															padding: "8px 16px",
															fontSize: "12px",
															fontWeight: "500",
															display: "flex",
															alignItems: "center",
															justifyContent: "center",
															gap: "8px",
															cursor: "pointer",
															boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
															transition: "all 0.2s ease",
															height: "38px",
															minWidth: "220px"
														}}
														onMouseEnter={(e) => {
															e.currentTarget.style.transform = "translateY(-1px)";
															e.currentTarget.style.boxShadow = "0 6px 14px rgba(0,0,0,0.12)";
														}}
														onMouseLeave={(e) => {
															e.currentTarget.style.transform = "translateY(0px)";
															e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.08)";
														}}
													>
														<i className="fa fa-plus-circle"></i>
														Nueva razón social
													</button>
												</Col>

											</Row>
											<br />
											<Row >
												<Col md="3">
													<FormGroup>
														<Label className="label-admision">Estado <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
														<Input
															className="input-admision"
															type="select"
															name="id_state"
															onChange={(e) => handleChangeState(e, "id_state", "listCompanyBusinessNames")}
															defaultValue={obj.id_state}
															data-id={index}>
															<option value={0}>Selecciona una opción</option>
															{
																states.length >= 1 && states.map((s, key) => {
																	return <option value={s.id_state} key={key} selected={(obj.id_state !== null) ? (obj.id_state === s.id_state ? 'selected' : '') : ''}>{s.name}</option>
																})
															}
														</Input>
													</FormGroup>
												</Col>
												<Col md="3">
													<FormGroup>
														<Label className="label-admision" >Municipio <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
														<Input
															className="input-admision"
															type="select"
															name="id_municipality"
															onChange={(e) => handleDinamicInputRFC(e, "id_municipality", "listCompanyBusinessNames")}
															defaultValue={obj.id_municipality}
															data-id={index}
														>
															<option value={0}>Selecciona una opción</option>
															{
																(obj.listMunicipalities !== undefined && obj.listMunicipalities.length > 0) && obj.listMunicipalities.map((m, key) => {
																	return <option value={m.id_municipality} key={key} selected={(obj.id_municipality !== null) ? (obj.id_municipality === m.id_municipality ? 'selected' : '') : ''}>{m.name}</option>
																})
															}
														</Input>
													</FormGroup>
												</Col>
												<Col md="3">
													<FormGroup>
														<Label className="label-admision">Tipo de persona <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
														<Input className="input-admision"
															type='select' name="type_person" onChange={(e) => handleDinamicInputRFC(e, 'type_person', 'listCompanyBusinessNames')} defaultValue={obj.type_person} data-id={index}>
															<option value={0}>Selecciona una opción</option>
															<option value={1}>Física</option>
															<option value={2}>Moral</option>
														</Input>
													</FormGroup>
												</Col>
												<Col md="3">
													<FormGroup>
														<Label className="label-admision">Régimen fiscal <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
														<Input
															className="input-admision"
															type='select'
															name='id_tax_regime'
															onChange={(e) => handleDinamicInputRFC(e, 'id_tax_regime', 'listCompanyBusinessNames')}
															defaultValue={obj.id_tax_regime}
															data-id={index}
														>
															<option value={0}>Selecciona una opción</option>
															{
																listTaxRegime.length > 0 && listTaxRegime.map((x, k) => {
																	return <option value={x.value} key={k} selected={obj.id_tax_regime === x.value ? true : false} >{x.label}</option>
																})
															}
														</Input>
													</FormGroup>
												</Col>
											</Row>
										</Col>
										<Col sm="12">
											<Row className='mt-2'>
												<Col md="3">
													<FormGroup>
														<Label className="label-admision">Código postal <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
														<Input
															className="input-admision"
															type="number"
															name="cp"
															autoComplete="nope"
															onChange={(e) => handleDinamicInputRFC(e, "cp", "listCompanyBusinessNames")}
															value={obj.cp}
															data-id={index}
														/>
														<FormFeedback>Ingresa un código postal valido</FormFeedback>
													</FormGroup>
												</Col>
												<Col md="3">
													<FormGroup>
														<Label className="label-admision">Dirección <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
														<Input
															className="input-admision"
															type="text"
															name="address"
															autoComplete="nope"
															onChange={(e) => handleDinamicInputRFC(e, "address", "listCompanyBusinessNames")}
															value={obj.address}
															data-id={index}

														/>
														<FormFeedback>El campo debe tener 3 o más caracteres</FormFeedback>
													</FormGroup>
												</Col>
												<Col md="3">
													<FormGroup>
														<Label className="label-admision">Colonia <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
														<Input
															className="input-admision"
															type="text"
															name="colony"
															autoComplete="nope"
															onChange={(e) => handleDinamicInputRFC(e, "colony", "listCompanyBusinessNames")}
															value={obj.colony}
															data-id={index}
														/>
														<FormFeedback>El campo debe tener 3 o más caracteres</FormFeedback>
													</FormGroup>
												</Col>

												<Col md="3">
													<FormGroup>
														<Label className="label-admision">Teléfono <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
														<Input
															className="input-admision"
															type="text"
															name="phone"
															autoComplete="nope"
															onChange={(e) => handleDinamicInputRFC(e, "phone", "listCompanyBusinessNames")}
															value={obj.phone}
															data-id={index}
														/>
														<FormFeedback>Número telefonico a 10 digitos</FormFeedback>
													</FormGroup>
												</Col>
												<Col md="12">
													<FormGroup>
														<Label className="label-admision">Correo electrónico&nbsp; <label style={{ color: "#1d5b83" }} > (En caso de requerir más de un correo separar con el símbolo&nbsp;"," ) </label><span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
														<Input
															className="input-admision"
															type="text"
															name="email"
															autoComplete="nope"
															onChange={(e) => handleDinamicInputRFC(e, "email", "listCompanyBusinessNames")}
															value={obj.email}
															data-id={index}
														/>
														<FormFeedback>Ingresa una direccion valida</FormFeedback>
													</FormGroup>
												</Col>
												<Col sm="12">
													<Button type="button" color="dark" size='sm' onClick={() => handleNewBussines(index)}>
														<span className="fa fa-plus-circle"></span>&nbsp; Agregar multiples direcciones
													</Button>
													<div>
														{Array.isArray(obj.ArrayAddressCompany) && obj.ArrayAddressCompany.length > 0 && obj.ArrayAddressCompany.map((address, addressIndex) => (
															<div key={addressIndex}>
																<Col sm="12" className='p-l-0 p-r-0 pt-2' >
																	<Row>
																		<Col sm="11">
																			<label className="label-admision" style={{ color: "#1d5b83" }}>Dirección {addressIndex + 1}</label>
																			<Input
																				className="input-admision"
																				type="text"
																				name="address"
																				value={address.address}
																				onChange={(e) => handleAddressInput(e, index, addressIndex)}
																			/>
																		</Col>
																		<Col sm="1" className='pt-4 p-l-0'   >
																			<i className="fa fa-trash-o f-28 txt-danger pointer" title='Eliminar' onClick={() => handleDeleteAddress(index, addressIndex)}></i>
																		</Col>
																	</Row>
																</Col>
															</div>
														))}
													</div>
												</Col>
											</Row>
											<Row>
												<Col sm="4">
												</Col>
												<Col sm="8" style={{ textAlign: "-webkit-right" }}>
													{
														button === "Guardar" && listCompanyBusinessNames.length > 1 ?
															<ButtonGroup>
																<Button
																	className=" btn-air-danger "
																	outline color="danger"
																	size="xs"
																	key={index}
																	onClick={() => removeAlterCompanies(index)}><i className="fa fa-trash-o"></i></Button>
															</ButtonGroup>
															:
															""
													}
												</Col>
											</Row>
											<br />
											<br />
										</Col>
									</Row>
								)
							})
						}

					</Col>
				</div>
			)}




		</>

	)
}
